import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import Logo from "./Logo";
import { setAuthToken } from "../lib/api";
import { setMemberToken, useMemberAuth } from "../lib/memberAuth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleAuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { refresh } = useMemberAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
      const portal = window.location.pathname.startsWith("/admin") ? "admin" : "account";
      window.history.replaceState(null, "", window.location.pathname);
      try {
        const r = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/google/session`, {
          session_id: sessionId,
          portal,
        });
        if (portal === "admin") {
          setAuthToken(r.data.token);
          toast.success("Welcome back.");
          navigate("/admin/dashboard", { replace: true });
        } else {
          setMemberToken(r.data.token);
          await refresh();
          toast.success("Welcome back.");
          navigate("/account", { replace: true });
        }
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google sign-in failed.");
        navigate(portal === "admin" ? "/admin" : "/account/login", { replace: true });
      }
    };
    run();
  }, [navigate, refresh]);

  return (
    <section className="min-h-screen flex flex-col items-center justify-center bg-[#0A0A0A] gap-8" data-testid="google-auth-callback">
      <Logo variant="vertical" />
      <p className="eyebrow animate-pulse">Verifying your account…</p>
    </section>
  );
}
